import { PortfolioCard } from './PortfolioCard'
import type { Project } from '@/data/portfolio'

interface RelatedProjectsProps {
  projects: Project[]
  currentSlug: string
}

export function RelatedProjects({ projects, currentSlug }: RelatedProjectsProps) {
  if (!projects || projects.length === 0) return null

  // Filter out the current project
  const relatedProjects = projects.filter((p) => p.slug !== currentSlug).slice(0, 3)

  if (relatedProjects.length === 0) return null

  return (
    <div className="my-16">
      <h2 className="mb-6 text-2xl font-semibold">Related Projects</h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {relatedProjects.map((project) => (
          <PortfolioCard key={project.slug} {...project} />
        ))}
      </div>
    </div>
  )
}
